<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'App',

  beforeCreate() {
    const Manager = window.Laravel.hasOwnProperty('Manager') ? window.Laravel.Manager : null;
    const User = window.Laravel.hasOwnProperty('User') ? window.Laravel.User : null;
    const Taxpayer = window.Laravel.hasOwnProperty('Taxpayer') ? window.Laravel.Taxpayer : null;

    this.$store.dispatch('auth/setManager', Manager);
    this.$store.dispatch('auth/setUser', User);
    this.$store.dispatch('auth/setTaxpayer', Taxpayer);
  },

  computed: {
    ...mapGetters(['getThemeMode']),

    themeName() {
      return this.getThemeMode.dark ? 'dark-theme' : '';
    },

    rtl() {
      return this.getThemeMode.rtl ? 'rtl' : '';
    },
  },

  metaInfo() {
    return {
      title: 'Home',
      titleTemplate: '%s | Invoice Gateway System',
      bodyAttrs: {
        class: [this.themeName, 'text-left'],
      },
      htmlAttrs: {
        dir: this.rtl,
      },
    };
  },
};
</script>
